import { Route } from 'react-router-dom'
import { Page } from '~/components/Page'
import { StoreProvider } from './providers/store'
import { PageBanner } from '~/components/PageBanner'
import { Store } from './components/Store'
import { RequireAuth } from '~/components/Auth'
const bannerImage = new URL('assets/banner.png', import.meta.url).toString()

const StorePage = () => {
    return (
        <RequireAuth>
            <Page title='Store' header='Store'>
                <PageBanner imageURL={bannerImage} text='STORE' />
                <StoreProvider>
                    <Store />
                </StoreProvider>
            </Page>
        </RequireAuth>
    )
}

export const StoreRoutes = [<Route key='store-index' index element={<StorePage />} />]
